import gql from 'graphql-tag';

const USER_RESPONSE = `
access_token
refresh_token
tfa_required
tfa_setup
tfa_secret
provisioning_uri
user {
  id
  is_admin
  role
  eula_accepted
  permissions
  password_update_required
  organization
}
`;

const AUTH_LOGIN = gql`
  mutation login(
    $email: String!
    $password: String!
    $use_ldap: Boolean
    $domain_id: String
  ) {
    loginResponse(
      input: {
        email: $email
        password: $password
        use_ldap: $use_ldap
        domain_id: $domain_id
      }
    ) @rest(type: "Login", path: "/auth/login/", method: "POST") {
      ${USER_RESPONSE}
    }
  }
`;

const AUTH_2FA_SETUP = gql`
  mutation setup2FA($tfaCode: String!, $tfaSecret: String!, $userId: Int!) {
    setup2FAResponse(
      input: { tfa_code: $tfaCode, tfa_secret: $tfaSecret, user_id: $userId }
    ) @rest(type: "Setup2FA", path: "/auth/2fa/setup/", method: "POST") {
      ${USER_RESPONSE}
    }
  }
`;

const AUTH_2FA_VALIDATE = gql`
  mutation validate2FA($tfaCode: String!, $userId: Int!) {
    validate2FAResponse(input: { tfa_code: $tfaCode, user_id: $userId })
      @rest(type: "Setup2FA", path: "/auth/2fa/validate/", method: "POST") {
      ${USER_RESPONSE}
    }
  }
`;

const AUTH_REFRESH_TOKEN = gql`
  mutation refreshToken($refresh: String!) {
    refreshTokenResponse(input: { refresh: $refresh })
      @rest(
        type: "RefreshToken"
        path: "/auth/token/refresh/"
        method: "POST"
      ) {
      access
    }
  }
`;

const AUTH_CHANGE_PASSWORD = gql`
  mutation changePassword($oldPassword: String!, $newPassword: String!) {
    changePasswordResponse(input: { old_password: $oldPassword, new_password: $newPassword })
      @rest(
        type: "ChangePassword"
        path: "/auth/change_password/"
        method: "POST"
      ){
        ${USER_RESPONSE}
      }
  }
`;

const AUTH_UPDATE_ORGANIZATION = gql`
mutation updateOrganization($organizationId: String!, $body: Object!) {
  updateOrganization: publish(body: $body, organizationId: $organizationId, input: {})
    @rest(
      type: "UpdateOrganization"
      path: "/auth/organization/{args.organizationId}/"
      method: "PATCH"
      bodyKey: "body"
    ) {
    id
    fqdn
    serverIP:server_ip
    offline
    os
    name
    serverVersion:server_version
  }
}
`;

export default {
  AUTH_LOGIN,
  AUTH_2FA_SETUP,
  AUTH_2FA_VALIDATE,
  AUTH_REFRESH_TOKEN,
  AUTH_CHANGE_PASSWORD,
  AUTH_UPDATE_ORGANIZATION
};
